/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartCheckoutOfferButton_item$ref = any;
type CartCheckoutOfferButton_transaction$ref = any;
type CartCustomHold_item$ref = any;
type CartMakeOfferButton_item$ref = any;
type CartPurchaseButton_item$ref = any;
type CartRequestPriceButton_item$ref = any;
export type CartItemCTA_item$ref = any;
export type CartItemCTA_item = {
    readonly serviceId: string | null;
    readonly returnPolicy: {
        readonly accept: unknown | null;
    } | null;
    readonly shipmentQuotes: ReadonlyArray<{
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
    } | null> | null;
    readonly pricing: {
        readonly negotiable: unknown | null;
    } | null;
    readonly lastTransaction?: {
        readonly " $fragmentRefs": CartCheckoutOfferButton_transaction$ref;
    } | null;
    readonly displayInfo: {
        readonly ctas: {
            readonly showAcceptOffer: boolean | null;
            readonly showMakeOffer: boolean | null;
            readonly showPurchase: boolean | null;
            readonly showRequestPrice: boolean | null;
        } | null;
        readonly pricing: {
            readonly showOnHold: boolean | null;
            readonly showOnHoldCustom: boolean | null;
            readonly showSold: boolean | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": CartCustomHold_item$ref & CartRequestPriceButton_item$ref & CartCheckoutOfferButton_item$ref & CartPurchaseButton_item$ref & CartMakeOfferButton_item$ref;
    readonly " $refType": CartItemCTA_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userId"
    } as any);
    return {
        "kind": "Fragment",
        "name": "CartItemCTA_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "returnPolicy",
                "storageKey": null,
                "args": null,
                "concreteType": "ReturnPolicy",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "accept",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuotes",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "amount",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "negotiable",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "displayInfo",
                "storageKey": null,
                "args": [
                    (v0 /*: any*/),
                    {
                        "kind": "Literal",
                        "name": "page",
                        "value": "pdp"
                    }
                ],
                "concreteType": "ItemDisplayInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ctas",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showAcceptOffer",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showMakeOffer",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showPurchase",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showRequestPrice",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pricing",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showOnHold",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showOnHoldCustom",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showSold",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "CartCustomHold_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartRequestPriceButton_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartCheckoutOfferButton_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartPurchaseButton_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartMakeOfferButton_item",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "lastTransaction",
                        "storageKey": null,
                        "args": [
                            (v0 /*: any*/)
                        ],
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "CartCheckoutOfferButton_transaction",
                                "args": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '5739bdc96f99ba0cfea75c6a184d84c2';
export default node;
